import React, { useContext } from "react";
import Headline from "~/assets/js/components/Typography/Headline";
import i18next from "i18next";
import OrderCard from "~/assets/js/components/OrderCard";
import { useUserOngoingOrders } from "~/assets/js/Api/userApi";
import { CustomerAreaContext, ACTIONS } from "../../CustomerAreaProvider";

const MAX_ONGOING_ORDERS = 2;

const OngoingOrder = () => {
    const { dispatch } = useContext(CustomerAreaContext);
    const { orders, isError } = useUserOngoingOrders();
    const noOrders = orders && !orders.length;

    if (isError || noOrders) {
        return null;
    }

    const lastOngoingOrders = orders?.slice(0, MAX_ONGOING_ORDERS);

    const handleClick = (order) =>
        dispatch({ type: ACTIONS.SET_ORDER, payload: order });

    return (
        <>
            <Headline size={6}>
                {i18next.t("customerArea.ongoingOrder.title")}
            </Headline>
            {lastOngoingOrders &&
                lastOngoingOrders.map((order) => {
                    return (
                        <OrderCard
                            key={`ongoing-order-${order.uid}`}
                            order={order}
                            isOngoing
                            handleClick={() => handleClick(order)}
                        />
                    );
                })}
        </>
    );
};

export default OngoingOrder;
